<template>
  <div style="height: 450px">
    <div class="dinwdw">
      <div class="name_boxr">来源广告主(可选)：</div>
      <div style="display: flex">
        <div>
          <el-button
            type="primary"
            size="mini"
            @click="chooseoperatetwo(1)"
          >选择</el-button>
          <div>
            <el-button
              v-show="query.source_account_id.length !== 0"
              type="warning"
              size="mini"
              @click="query.source_account_id = []"
            >清空</el-button>
          </div>
        </div>
        <div style="max-height: 200px; overflow-y: scroll; position: relative">
          <el-tag
            v-for="(itemrse, indexr) in query.source_account_id"
            :key="indexr"
            style="margin-right: 10px; margin-bottom: 5px"
            closable
            :type="'success'"
            @close="rightclicktwo(itemrse, indexr)"
          >
            {{ itemrse.advertiser_name }}
          </el-tag>
        </div>
      </div>
    </div>
    <div class="dinwdw">
      <div class="name_boxr">目标广告主(可选)：</div>
      <div style="display: flex">
        <div>
          <el-button
            type="primary"
            size="mini"
            @click="chooseoperatetwo(2)"
          >选择</el-button>
          <div>
            <el-button
              v-show="query.to_account_id.length !== 0"
              type="warning"
              size="mini"
              @click="query.to_account_id = []"
            >清空</el-button>
          </div>
        </div>
        <div style="max-height: 200px; overflow-y: scroll; position: relative">
          <el-tag
            v-for="(itemrse, indexr) in query.to_account_id"
            :key="indexr"
            style="margin-right: 10px; margin-bottom: 5px"
            closable
            :type="'success'"
            @close="rightclicktwoGroup(itemrse, indexr)"
          >
            {{ itemrse.advertiser_name }}
          </el-tag>
        </div>
      </div>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogAdmin_id"
      width="800px"
      append-to-body
    >
      <wechatAuthAccount ref="admin" @bandarr="bandarrtwo" />
    </el-dialog>
    <div style="float: right; margin-top: 20px">
      <el-button type="primary" size="mini" @click="submit">确定</el-button>
    </div>
  </div>
</template>

<script>
import wechatAuthAccount from './wechatAuthAccount.vue'

export default {
  components: { wechatAuthAccount },
  data() {
    return {
      dialogAccountIds: false,
      dialogAdmin_id: false,
      query: {
        name: '',
        source_account_id: [],
        to_account_id: []
      },
      admin: {},
      sourceAdmin: {},
      title: ''
    }
  },
  created() {},
  mounted() {},
  methods: {
    submit() {
      const obj = {
        name: this.query.name
      }
      if (this.query.source_account_id.length !== 0) {
        obj.source_account_id = this.query.source_account_id.map(
          (v) => v.account_id
        )
      }
      if (this.query.to_account_id.length !== 0) {
        obj.to_account_id = this.query.to_account_id.map((v) => v.account_id)
      }

      console.log('obj:', obj)
      this.$emit('callbackbacer', obj, this.query)
      this.query = {
        name: '',
        source_account_id: [],
        to_account_id: []
      }
    },
    sendr(item) {
      this.query.name = localStorage.getItem('Larke-Admin-Token')
      if (item !== undefined) {
        this.query = item
      }
    },
    bandarrtwo(arr) {
      if (this.type === 1) {
        this.query.account_ids = []
        this.query.source_account_id = arr
      } else {
        this.query.account_ids = []
        this.query.to_account_id = arr
      }
      this.dialogAdmin_id = false
    },
    rightclicktwo(indexr) {
      this.query.source_account_id.splice(indexr, 1)
    },
    rightclicktwoGroup(indexr) {
      this.query.to_account_id.splice(indexr, 1)
    },
    chooseoperatetwo(type) {
      this.type = type
      this.dialogAdmin_id = true

      if (type === 1) {
        this.title = '选择来源广告主'
        this.$nextTick(() => {
          this.$refs.admin.sendr(this.query.source_account_id)
        })
      } else {
        this.title = '选择目标广告主'
        this.$nextTick(() => {
          this.$refs.admin.sendr(this.query.to_account_id)
        })
      }
    }
  }
}
</script>

<style scoped>
/* @import url(); 引入css类 */
.dinwdw {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.name_boxr {
  color: rgb(169, 162, 151);
  font-size: 14px;
  width: 140px;
  text-align: right;
  flex-shrink: 0;
}
</style>
